import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { env } from '../../../../environments/environment';
import {
  AuthRuntimeConfig,
  PublicAuthConfigDto,
} from '../../models/public-auth-config.model';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  readonly #http = inject(HttpClient);
  #authConfig: AuthRuntimeConfig | null = null;

  /** Carica la config OAuth dal BE e la mette in cache. */
  loadAuthConfig(): Promise<AuthRuntimeConfig> {
    const url = `${env.api.baseUrlPublic}/config`;
    return firstValueFrom(this.#http.get<PublicAuthConfigDto>(url)).then((dto) => {
      this.#authConfig = this.#toAuthConfig(dto);
      return this.#authConfig;
    });
  }

  getAuthConfig(): AuthRuntimeConfig {
    if (!this.#authConfig) {
      throw new Error('Auth config non caricata: chiamare loadAuthConfig() prima.');
    }
    return this.#authConfig;
  }

  #toAuthConfig(dto: PublicAuthConfigDto): AuthRuntimeConfig {
    const origin = window.location.origin;
    return {
      clientId: dto.clientId,
      responseType: dto.responseType,
      scope: dto.scope,
      redirectUri: `${origin}/mp/my-area`,
      post_logout_redirect_uri: `${origin}/home`,
      loginUrl: dto.loginUrl,
      issuer: dto.issuer,
      tokenEndpoint: dto.tokenEndpoint,
      userinfoEndpoint: dto.userinfoEndpoint,
      logoutUrl: dto.logoutUrl,
    };
  }
}
